import React, {
  useState,
  useContext,
  useEffect,
} from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core';
import {
  VALIDATOR_REQUIRE,
} from '../../utils/validators';
import Seletor from '../../shared/component/FormElements/Seletor';
import Button from '../../shared/component/FormElements/Button';
import Interruptor from '../../shared/component/FormElements/Interruptor';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';

// Alerta
import Alerta from './Alerta';

const Permissoes = () => {
  const auth = useContext(AuthContext);
  // const classes = useStyles();
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    permissao: {
      value: false,
      isValid: false
    },
    list_acervos: {
      value: false,
      isValid: true
    },
    create_acervos: {
      value: false,
      isValid: true
    },
    update_acervos: {
      value: false,
      isValid: true
    },
    delete_acervos: {
      value: false,
      isValid: true
    },
    list_doadores: {
      value: false,
      isValid: true
    },
    create_doadores: {
      value: false,
      isValid: true
    },
    update_doadores: {
      value: false,
      isValid: true
    },
    delete_doadores: {
      value: false,
      isValid: true
    },
    list_mapas: {
      value: false,
      isValid: true
    },
    create_mapas: {
      value: false,
      isValid: true
    },
    update_mapas: {
      value: false,
      isValid: true
    },
    delete_mapas: {
      value: false,
      isValid: true
    },
    list_situacoes: {
      value: false,
      isValid: true
    },
    create_situacoes: {
      value: false,
      isValid: true
    },
    update_situacoes: {
      value: false,
      isValid: true
    },
    delete_situacoes: {
      value: false,
      isValid: true
    },
    create_anexos: {
      value: false,
      isValid: true
    },
    relatorios: {
      value: false,
      isValid: true
    },
    all_admin: {
      value: false,
      isValid: true
    },
  }, true);
  const [salvou, setSalvou] = useState(false);
  const [permissoes, setPermissoes] = useState([]);
  const [permissao, setPermissao] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePermissaoSelecionada = (perm) => {
    console.log(perm);
    const perms = permissoes.filter((p) => p._id === perm);
    if (perms.length > 0) {
      console.log(perms);
      setPermissao(false);
      setLoading(true);
      setTimeout(() => {
        setPermissao(perms[0]);
      }, 500);
    } else {
      setPermissao(false);
    }
  };

  useEffect(() => {
    const fetchPermissoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/usuarios/permissao`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setPermissoes(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchPermissoes();
  }, [sendRequest, auth, salvou]);

  const permissaoSubmitHandler = async (event) => {
    event.preventDefault();
    console.log('Inputs');
    console.log(formState.inputs);
    try {
      const formulario = {
        permissao: formState.inputs.permissao.value,
        list_acervos: formState.inputs.list_acervos.value,
        create_acervos: formState.inputs.create_acervos.value,
        update_acervos: formState.inputs.update_acervos.value,
        delete_acervos: formState.inputs.delete_acervos.value,
        list_doadores: formState.inputs.list_doadores.value,
        create_doadores: formState.inputs.create_doadores.value,
        update_doadores: formState.inputs.update_doadores.value,
        delete_doadores: formState.inputs.delete_doadores.value,
        list_mapas: formState.inputs.list_mapas.value,
        create_mapas: formState.inputs.create_mapas.value,
        update_mapas: formState.inputs.update_mapas.value,
        delete_mapas: formState.inputs.delete_mapas.value,
        list_situacoes: formState.inputs.list_situacoes.value,
        create_situacoes: formState.inputs.create_situacoes.value,
        update_situacoes: formState.inputs.update_situacoes.value,
        delete_situacoes: formState.inputs.delete_situacoes.value,
        create_anexos: formState.inputs.create_anexos.value,
        relatorios: formState.inputs.relatorios.value,
        all_admin: formState.inputs.all_admin.value,
      };
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/usuarios/permissao/`,
        'PUT',
        JSON.stringify(formulario),
        {
          'Content-Type': 'application/json',
          'x-access-token': auth.token,
        }
      );
      if (response.sucesso) {
        console.log(response.data);
        clearError();
        setSalvou(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    console.log(permissao);
    if (permissao !== false) {
      setLoading(false);
    }
  }, [permissao]);

  const fechar = () => {
    setSalvou(false);
  };

  if (isLoading && permissao === []) {
    return (
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          <LoadingSpinner asOverlay />
        </Grid>
      </Grid>
    );
  }

  return (
    <form onSubmit={permissaoSubmitHandler}>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
        >
          <Card>
            <CardHeader
              subheader="Configurações Administrativas"
              title="ADMIN"
            />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={6}
                  xs={6}
                >
                  <Seletor
                    id="permissao"
                    name="permissao"
                    onInput={inputHandler}
                    label="Permissão"
                    placeholder="Permissão"
                    blank="Selecione a permissão da Loja"
                    fullWidth
                    variant="outlined"
                    data={permissoes.map((u) => {
                      return { label: u.nome, id: u._id };
                    })}
                    errorText="Selecione a permissão de acesso do loja a ser editada."
                    validators={[VALIDATOR_REQUIRE()]}
                    onChange={handlePermissaoSelecionada}
                  />
                </Grid>
              </Grid>
              {loading && (
                <div style={{ marginTop: '15px' }}>
                  <LinearProgress />
                </div>
              )}
              {permissao && (
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões do Acervo
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="list_acervos"
                      name="list_acervos"
                      onInput={inputHandler}
                      label="Listar Acervo"
                      dica="Listar acervos."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('list_acervos')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="create_acervos"
                      name="create_acervos"
                      onInput={inputHandler}
                      label="Criar item do Acervo"
                      dica="Criar itens do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('create_acervos')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="update_acervos"
                      name="update_acervos"
                      onInput={inputHandler}
                      label="Editar Acervo"
                      dica="Editar item do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('update_acervos')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="delete_acervos"
                      name="delete_acervos"
                      onInput={inputHandler}
                      label="Deletar Acervo"
                      dica="Deletar item do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('delete_acervos')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="list_doadores"
                      name="list_doadores"
                      onInput={inputHandler}
                      label="Listar Doadores"
                      dica="Listar doadores."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('list_doadores')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="create_doadores"
                      name="create_doadores"
                      onInput={inputHandler}
                      label="Criar doador do acervo"
                      dica="Criar doador do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('create_doadores')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="update_doadores"
                      name="update_doadores"
                      onInput={inputHandler}
                      label="Editar Doador"
                      dica="Editar doador do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('update_doadores')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="delete_doadores"
                      name="delete_doadores"
                      onInput={inputHandler}
                      label="Deletar Doador"
                      dica="Deletar doador do acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('delete_doadores')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões do Mapa
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="list_mapas"
                      name="list_mapas"
                      onInput={inputHandler}
                      label="Listar Salas"
                      dica="Listar Salas do Mapa."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('list_mapas')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="create_mapas"
                      name="create_mapas"
                      onInput={inputHandler}
                      label="Criar sala do Mapa"
                      dica="Criar sala do Mapa"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('create_mapas')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="update_mapas"
                      name="update_mapas"
                      onInput={inputHandler}
                      label="Editar Sala"
                      dica="Editar sala do mapa"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('update_mapas')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="delete_mapas"
                      name="delete_mapas"
                      onInput={inputHandler}
                      label="Deletar Sala"
                      dica="Deletar sala do mapa."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('delete_mapas')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões de Situações do Acervo
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="list_situacoes"
                      name="list_situacoes"
                      onInput={inputHandler}
                      label="Listar Situações do Acervo"
                      dica="Listar Situações do Acervo."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('list_situacoes')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="create_situacoes"
                      name="create_situacoes"
                      onInput={inputHandler}
                      label="Criar Situações do Acervo"
                      dica="Criar Situações do Acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('create_situacoes')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="update_situacoes"
                      name="update_situacoes"
                      onInput={inputHandler}
                      label="Editar Situação"
                      dica="Editar Situação do Acervo"
                      validators={[]}
                      initialValue={permissao.permissoes.includes('update_situacoes')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="delete_situacoes"
                      name="delete_situacoes"
                      onInput={inputHandler}
                      label="Deletar Situação do Acervo"
                      dica="Deletar Situação do Acervo."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('delete_situacoes')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões de Arquivos
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="create_anexos"
                      name="create_anexos"
                      onInput={inputHandler}
                      label="Criar anexos"
                      dica="Criar anexos."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('create_anexos')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões de Análise
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="relatorios"
                      name="relatorios"
                      onInput={inputHandler}
                      label="Acesso aos Relatórios"
                      dica="Pode visualizar os relatórios."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('relatorios')}
                      initialValid
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                    >
                      Permissões Administrativas
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={6}
                  >
                    <Interruptor
                      id="all_admin"
                      name="all_admin"
                      onInput={inputHandler}
                      label="Acesso Administrativo"
                      dica="Pode criar novos usuários, editá-los e definir seus níveis de acesso."
                      validators={[]}
                      initialValue={permissao.permissoes.includes('all_admin')}
                      initialValid
                    />
                  </Grid>
                </Grid>
              )}
            </CardContent>
            <Divider />
            <Box
              display="flex"
              justifyContent="flex-start"
              p={2}
            >
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={!formState.isValid}
              >
                Salvar
              </Button>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          lg={4}
          md={6}
          xs={12}
        >
          {isLoading && <LoadingSpinner asOverlay />}
          <ErrorMessage error={error} onClear={clearError} />
        </Grid>
      </Grid>
      <Alerta open={salvou} close={fechar} tipo="success">
        Permissões do nível de acesso
        {` ${permissao.nome} `}
        atualizadas com sucesso!
      </Alerta>
    </form>
  );
};

export default Permissoes;
